module.exports = "https://static.wanderu.com/ui-react/_next/static/media/economist-x2.52b81e9f.png";